// Auth0 authentication integration configuration

// TODO: REFACTOR THIS INTO THE MAIN AppConfiguration area
export const AuthConfig = {
    // Auth configuration
    tokenPayloadPaths: {
      userRoles: 'http://complex-reserve/user-roles',
      userProfileNickname: 'http://complex-reserve/user-profile.nickname',
      userProfileObjectId: 'http://complex-reserve/user-profile.user_id',
      userProfileEmail: 'http://complex-reserve/user-profile.email',
      userContact: 'http://complex-reserve/user-contact',
      userPasswordChangeRequired: 'profile.http://complex-reserve/user-password-change-required',
    },

    ProfilePaths: {
      userRoles: 'profile.http://complex-reserve/user-roles',
      userProfileNickname: 'profile.http://complex-reserve/user-profile.nickname',
      userProfileObjectId: 'profile.http://complex-reserve/user-profile.user_id',
      userProfileEmail: 'profile.http://complex-reserve/user-profile.email',
      userContact: 'profile.http://complex-reserve/user-contact',
      userPasswordChangeRequired: 'profile.http://complex-reserve/user-password-change-required',
    },

    LocalStorageTokens: {
      accessToken: 'access_token',
      expiresAt: 'expires_at',
      loggedOutAt: 'logged_out_at',
      passwordChangeRequired: 'password_change_required',
      idToken: 'id_token',
      profile: 'profile',
      redirectToAfterLogin: 'redirect_to_after_login',
      redirectToAddBid: 'redirect_to_add_bid',
      redirectToAddBidNewClientId: 'redirect_to_add_bid_new_client_id',
      redirectToAddBidNewClientContactId: 'redirect_to_add_bid_new_client_contact_id',
      redirectToAddBidNewAssociationId: 'redirect_to_add_bid_new_association_id',
    },

    UserRoles: {
      roleName: 'name',
      administrator: 'administrator',
      client: 'client',
      clientReadOnly: 'client_read_only',
      employee: 'employee'
    }
  };



// WEBPACK FOOTER //
// ./src/config/authconfiguration.tsx